import { createSelector } from '@ngrx/store';
import { MeaState } from '../state/mea.state';
import { PharmacyState } from '../state/pharmacy.state';

export const selectPharmacyData = (state: MeaState) => state.pharmacyData;

export const selectChatPartnerPharmacy = createSelector(selectPharmacyData, (state: PharmacyState) => state.pharmacy);
